<template>
  <div>
    <div class="agendaTable">
      <div class="row" id="pnlTitleBar" v-if="profgroupName !== ''">
        <div class="col-12">
          <span id="lblTitel" class="titel">{{ translation(93) + ' ' + profgroupName }}</span>
        </div>
      </div>
      <div
        class="row margin20 margin20bottom"
        id="lblBeschrijving"
        v-if="
          lblMaatwerkBeschrijving === '<p></p>' || lblMaatwerkBeschrijving === null || lblMaatwerkBeschrijving === ''
        "
      >
        <div class="col-12">
          <p v-html="translation(3294)"></p>
        </div>
      </div>
      <div
        class="row margin20 margin20bottom"
        id="lblBeschrijving"
        v-if="
          lblMaatwerkBeschrijving !== '<p></p>' && lblMaatwerkBeschrijving !== null && lblMaatwerkBeschrijving !== ''
        "
      >
        <div class="col-12">
          <p v-html="lblMaatwerkBeschrijving"></p>
        </div>
      </div>
      <div class="row margin20 margin20bottom" v-if="agendaTable.tabledata.length === 0 && !tableLoader" id="tableinfo">
        <div class="col-12">
          <div class="tableinfostyle">
            <span>{{ translation(16746) }}</span
            >&nbsp;<a href="#" @click="lblreset()">{{ translation(3346) }}</a>
          </div>
        </div>
      </div>
      <div class="row margin20 margin20bottom" v-if="agendaTable.tabledata.length > 0" id="tableinfo">
        <div class="col-12">
          <div>
            <span>{{ translation(16708) + '&nbsp;' + totalCount + '&nbsp;' + translation(16709) + ',' }}</span
            >&nbsp;<a href="#" @click="lblreset()">{{ translation(3346) }}</a>
          </div>
        </div>
      </div>
      <main class="XVtableVirtalScroll-container">
        <XVSticky
          class="XVtableVirtalScroll-header"
          :stickyHeight="stickyHeight"
          v-if="agendaTable.tabledata.length > 0"
        >
          <!-- v-if="filterinputdata.cbCourseType === 1" -->
          <portal-target name="XVtableVirtualScrollPortalhtml" slim></portal-target>
        </XVSticky>
        <div class="XVtableVirtalScroll-content">
          <XVtableflexV2
            :tablesetting="agendaTable.tablesetting"
            :tablecolumnsetting="agendaTable.tablecolumnsetting"
            :tabledata="agendaTable.tabledata"
            :rowvisible="agendaTable.rowvisible"
            v-on:sortXVTable="XVTablesort"
            :filterfunc="tabledata => tabledata"
            :XVtableSetRowStateProperty="XVtableSetRowStateProperty"
            :usePortalHeader="true"
            @ScrollBottom="nextTableData"
            :formatDateRelative="false"
          >
            <template slot="openDetail" slot-scope="dr">
              <span @click="openDetail(dr)" class="pointer">
                <font-awesome-icon icon="chevron-down" class="initial pointer" v-if="!dr.row.tableRowState.editModus" />
                <font-awesome-icon icon="chevron-up" class="initial pointer" v-if="dr.row.tableRowState.editModus" />
              </span>
            </template>
            <template slot="startDate" slot-scope="dr">
              <div class="pointer" @click="openDetail(dr)">
                <span>{{ dr.row.dateString }}</span>
              </div>
            </template>
            <template slot="extraColumn" slot-scope="dr">
              <span v-html="dr.celldata"></span>
            </template>
            <template slot="name" slot-scope="dr">
              <div class="pointer" @click="openDetail(dr)">
                <!-- (R)ejected, (A)ccepted, (P)ending -->
                <span v-if="dr.row.courseStatus === 'R'"
                  ><font-awesome-icon icon="times" class="text-danger" :title="translation(16730)"
                /></span>
                <span v-if="dr.row.courseStatus === 'A'"
                  ><font-awesome-icon :icon="['far', 'check']" class="text-success" :title="translation(16728)"
                /></span>
                <span v-if="dr.row.courseStatus === 'P'"
                  ><font-awesome-icon
                    :icon="['far', 'question-circle']"
                    class="glyphicon-question-sign text-danger"
                    :title="translation(16729)"
                /></span>
                <span
                  v-if="activeProfGr !== '' && dr.row.allowProfToAdd === 1"
                  @click="addPresentie(dr.row.courseId, dr.row.editionId)"
                  ><font-awesome-icon :icon="['fas', 'plus-square']" class="text-success" :title="translation(16943)"
                /></span>
                <span>{{ dr.celldata }}</span>
                <div
                  class="star-ratings-css"
                  v-if="
                    dr.row.rating && dr.row.rating.courseRatingAverage !== null && dr.row.rating.courseRatingCount !== 0
                  "
                >
                  <div class="star-ratings-css-top" :style="{ width: dr.row.rating.courseRatingAverage + '%' }">
                    <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                  </div>
                  <div class="star-ratings-css-bottom">
                    <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span
                    ><span class="starcount">{{ '(' + dr.row.rating.courseRatingCount + ')' }}</span>
                  </div>
                </div>
              </div>
            </template>
            <template slot="locationCity" slot-scope="dr">
              <div class="pointer" @click="openDetail(dr)">
                <span v-if="dr.row.isRemoteAttendance">
                  <font-awesome-icon :icon="['fas', 'video']" />
                </span>
                <span v-if="dr.row.locationCity !== ''">
                  {{ dr.row.locationCity }}
                </span>
                <span
                  v-if="
                    dr.row.locationCountryCode !== '' &&
                      dr.row.locationCountryCode !== null &&
                      dr.row.locationCity !== ''
                  "
                >
                  {{ '(' + dr.row.locationCountryCode + ')' }}
                </span>
              </div>
            </template>
            <template slot="educationInstituteName" slot-scope="dr">
              <div class="pointer" @click="openDetail(dr)">
                <span>{{ dr.celldata }}</span>
                <div class="star-ratings-css" v-if="dr.row.rating && dr.row.rating.educationRatingAverage">
                  <div class="star-ratings-css-top" :style="{ width: dr.row.rating.educationRatingAverage + '%' }">
                    <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                  </div>
                  <div class="star-ratings-css-bottom">
                    <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span
                    ><span class="starcount">{{ '(' + dr.row.rating.educationRatingCount + ')' }}</span>
                  </div>
                </div>
              </div>
            </template>
            <template slot="detailrow" slot-scope="tablerow">
              <div class="agendaTableDetailRow" v-if="tablerow.row.tableRowState.courseDetails">
                <div class="row" id="detailRowLocation" v-if="wXS === true || wSM === true || wMD === true">
                  <div class="col-12">
                    <h3>{{ translation(16720) }}</h3>
                  </div>
                  <div class="col-12 form-group">
                    <span v-if="tablerow.row.isRemoteAttendance">
                      <font-awesome-icon :icon="['fas', 'video']" />
                    </span>
                    <span v-if="tablerow.row.locationCity !== ''">
                      {{ tablerow.row.locationCity }}
                    </span>
                    <span
                      v-if="
                        tablerow.row.locationCountryCode !== '' &&
                          tablerow.row.locationCountryCode !== null &&
                          tablerow.row.locationCity !== ''
                      "
                    >
                      {{ '(' + tablerow.row.locationCountryCode + ')' }}
                    </span>
                  </div>
                </div>
                <div class="row" id="detailRowInstituteName" v-if="wXS === true || wSM === true || wMD === true">
                  <div class="col-12">
                    <h3>{{ translation(16721) }}</h3>
                  </div>
                  <div class="col-12 form-group">
                    <span>{{ tablerow.row.educationInstituteName }}</span>
                    <div
                      class="star-ratings-css"
                      v-if="tablerow.row.rating && tablerow.row.rating.educationRatingAverage"
                    >
                      <div
                        class="star-ratings-css-top"
                        :style="{ width: tablerow.row.rating.educationRatingAverage + '%' }"
                      >
                        <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                      </div>
                      <div class="star-ratings-css-bottom">
                        <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span
                        ><span class="starcount">{{ '(' + tablerow.row.rating.educationRatingCount + ')' }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" id="detailRowStatus" v-if="tablerow.row.courseId !== null">
                  <div class="col-12">
                    <h3>{{ translation(18908) }}</h3>
                  </div>
                  <div class="col-12 form-group">
                    <span v-if="tablerow.row.courseStatus === 'R'"
                      ><font-awesome-icon icon="times" class="text-danger" :title="translation(16730)" />{{
                        translation(16730)
                      }}</span
                    >
                    <span v-if="tablerow.row.courseStatus === 'A'"
                      ><font-awesome-icon :icon="['far', 'check']" class="text-success" :title="translation(16728)" />{{
                        translation(16728)
                      }}</span
                    >
                    <span v-if="tablerow.row.courseStatus === 'P'"
                      ><font-awesome-icon
                        :icon="['far', 'question-circle']"
                        class="glyphicon-question-sign text-danger"
                        :title="translation(16729)"
                      />{{ translation(16729) }}</span
                    >
                  </div>
                </div>
                <div class="row" id="detailRowDescription" v-if="tablerow.row.tableRowState.courseDetails.description">
                  <div class="col-12">
                    <h3>{{ translation(16716) }}</h3>
                    <span v-html="formattedDescription(tablerow.row.tableRowState.courseDetails.description)"></span>
                  </div>
                </div>
                <div v-if="!hideCoursePoints && tablerow.row.courseId !== null">
                  <div class="row">
                    <div class="col-12">
                      <h3>{{ translation(812) }}</h3>
                    </div>
                  </div>
                  <div
                    v-for="(categorie, index) in tablerow.row.tableRowState.courseDetails.categories"
                    :key="'cat' + index"
                  >
                    <div
                      class="row"
                      v-if="
                        tablerow.row.tableRowState.courseDetails.categories &&
                          tablerow.row.tableRowState.courseDetails.categories.length > 0
                      "
                    >
                      <div class="col-8 col-lg-4">
                        <span>{{ categorie.name }}</span>
                      </div>
                      <div class="col-4 col-lg-8">
                        <span>{{ categorie.points }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="row margin15 margin20bottom"
                  v-if="
                    tablerow.row.tableRowState.courseDetails.competences &&
                      tablerow.row.tableRowState.courseDetails.competences.length > 0
                  "
                >
                  <div class="col-12">
                    <h3>{{ translation(13459) }}</h3>
                  </div>

                  <div class="col-12">
                    <div class="competentiebalk">
                      <div
                        :id="'competentiebalk' + index"
                        v-for="(competentie, index) in tablerow.row.tableRowState.courseDetails.competences"
                        :key="'compbalk' + index"
                        :style="{ width: competentie.percentage + '%', backgroundColor: '#' + competentie.color }"
                      ></div>
                    </div>
                  </div>
                </div>
                <div
                  v-for="(competentie, index) in tablerow.row.tableRowState.courseDetails.competences"
                  :key="'comp' + index"
                >
                  <div
                    class="row"
                    v-if="
                      tablerow.row.tableRowState.courseDetails.competences &&
                        tablerow.row.tableRowState.courseDetails.competences.length > 0
                    "
                  >
                    <div class="col-4">
                      <span>{{ competentie.name }}</span>
                    </div>
                    <div class="col-8">
                      <span>{{ competentie.percentage + '%' }}</span>
                    </div>
                  </div>
                </div>
                <div class="row margin15 agendaDetailInfo">
                  <div class="col-12">
                    <font-awesome-icon :icon="['fas', 'info-circle']" /><a
                      @click="meerInfo(tablerow.row.courseId, tablerow.row.agendaSubjectId)"
                      class="pointer"
                      >{{ ' ' + translation(16717) }}</a
                    >
                  </div>
                </div>
              </div>
              <!-- {{ tablerow }} -->
            </template>
          </XVtableflexV2>
        </div>
        <footer class="XVtableVirtalScroll-footer bckcol-primary"></footer>
        <div v-show="tableLoader">
          <XVwaiter></XVwaiter>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { FAMixin } from 'pevueglobal'

export default {
  mixins: [FAMixin],
  data() {
    return {}
  },
  async mounted() {},
  computed: {
    ...mapGetters('Agenda', [
      'agendaTable',
      'profgroupid',
      'profgroupName',
      'filterinputdata',
      'lblMaatwerkBeschrijving',
      'hideCoursePoints',
      'stickyHeight',
      'totalCount',
      'activeProfGr',
      'activeProfOrgId',
      'tableLoader'
    ]),
    tablecolumnsvisible: function() {
      // Als de setting van de tablecolumn op visible = 1 staat, dan word hij getoond.
      let Itablecolumns = this.agendaTable.tablecolumnsetting.filter(function(d) {
        return d.visible === 1
      })
      return Itablecolumns
    },
    columnWidthStyles: function() {
      // bepaal de breedte a.h.v. definities in tblPEapiProcTableColumnWidth
      let temparray = []
      this.agendaTable.tablecolumnsetting.forEach(tablecolumn => {
        if (this.wXS) {
          if (tablecolumn.visible === 1 && tablecolumn.visibleXS === 1) {
            temparray.push({
              flex: tablecolumn.widthXS === null ? '0 0 auto' : tablecolumn.widthXS
            })
          } else {
            if (tablecolumn.visible === 1) {
              temparray.push({ flex: '0 0 auto' })
            }
          }
        }
        if (this.wSM) {
          if (tablecolumn.visible === 1 && tablecolumn.visibleSM === 1) {
            temparray.push({
              flex: tablecolumn.widthSM === null ? '0 0 auto' : tablecolumn.widthSM
            })
          } else {
            if (tablecolumn.visible === 1) {
              temparray.push({ flex: '0 0 auto' })
            }
          }
        }
        if (this.wMD || this.wXL || this.wLG) {
          if (tablecolumn.visible === 1 && tablecolumn.visibleMD === 1) {
            temparray.push({
              flex: tablecolumn.widthMD === null ? '0 0 auto' : tablecolumn.widthMD
            })
          } else {
            if (tablecolumn.visible === 1) {
              temparray.push({ flex: '0 0 auto' })
            }
          }
        }
      })
      return temparray
    },
    formattedDescription() {
      return text => {
        var valContainer = text
        var maxChars = 400
        if (text.length > maxChars) {
          let maxCharsSpace = text.indexOf(' ', maxChars)
          let maxCharsDot = text.indexOf('.', maxChars)
          let maxCharsClosesd = maxChars
          if (maxCharsSpace !== -1 && maxCharsDot !== -1) {
            maxCharsClosesd = Math.max(Math.min(maxCharsSpace, maxCharsDot), 0)
          } else if (maxCharsSpace === -1 && maxCharsDot !== -1) {
            maxCharsClosesd = maxCharsDot
          } else if (maxCharsSpace !== -1 && maxCharsDot === -1) {
            maxCharsClosesd = maxCharsSpace
          }
          valContainer = valContainer.substring(0, maxCharsClosesd) + '...'
        }
        return valContainer
      }
    }
  },
  methods: {
    ...mapActions('Agenda', ['getNextTableData', 'getCourseDetail', 'getLblReset']),
    ...mapMutations('Agenda', ['XVTablesort', 'XVtableSetRowStateProperty', 'nextPageSetting']),
    nextTableData() {
      this.getNextTableData()
    },
    meerInfo(courseid, agendaitemid) {
      if (courseid) {
        window.location = '/public/OpleidingDetail.aspx?courseID=' + courseid + '&pid=' + this.profgroupid
      } else if (agendaitemid) {
        window.location = '/public/AgendaDetail.aspx?agendaID=' + agendaitemid + '&pid=' + this.profgroupid
      }
    },
    lblreset() {
      this.getLblReset()
    },
    iscolumnvisible: function(colVisMd, colVisSm, colVisXs) {
      // responsive classes , geeft aan wanneer een kolom visible moet zijn
      let visclass = ''
      if (colVisXs === 0) {
        visclass = 'hidden-xs '
      }
      if (colVisSm === 0) {
        visclass = 'hidden-xs hidden-sm '
      }
      if (colVisMd === 0) {
        visclass = 'hidden-xs hidden-sm hidden-md hidden-lg '
      }
      return visclass
    },
    async openDetail(tablerow) {
      let editmodus = tablerow.row.tableRowState.editModus
      let rowIndex = tablerow.row.tableRowState.storeTableindex
      if (!editmodus && tablerow.row.courseId !== null) {
        this.startLoading({ showmessage: false, disablepage: false })
        await this.getCourseDetail({ courseId: tablerow.row.courseId, rowIndex: rowIndex })
        this.stopLoading()
      }
      let selectedCourse = this.agendaTable.tabledata.find(row => row.tableRowState.rowVisible === true)
      if (selectedCourse && tablerow.row.index !== selectedCourse.tableRowState.storeTableindex) {
        this.XVtableSetRowStateProperty({
          index: rowIndex,
          stateProperty: 'rowVisible',
          statePropertyValue: false
        })
        this.XVtableSetRowStateProperty({
          index: rowIndex,
          stateProperty: 'editModus',
          statePropertyValue: false
        })
      }

      this.XVtableSetRowStateProperty({
        index: tablerow.index,
        stateProperty: 'rowVisible',
        statePropertyValue: !editmodus
      })
      this.XVtableSetRowStateProperty({
        index: tablerow.index,
        stateProperty: 'editModus',
        statePropertyValue: !editmodus
      })
    },
    stopPropagationReply() {
      let e = window.event
      if (!e) {
        e.cancelBubble = true
      }
      if (e.stopPropagation) e.stopPropagation()
    },
    addPresentie(courseId, editionId) {
      this.stopPropagationReply()
      let url =
        '/allroles/wizards/Wizardpresentie/wzr_pres_step_00.aspx?courseid=' +
        courseId +
        '&proforgid=' +
        this.activeProfOrgId
      // als de scholing ook een uitvoering heeft (editionID is ingevuld) dan voegen we dit er aan toe: &courseEditionid={editionID}
      if (editionId) {
        url = url + '&courseEditionid=' + editionId
      }
      // als de prof is ingelogd maar een andere agenda bekijkt dan de profgroupID uit de cookie pe_activeProfGroup dan voegen we ook dit nog toe: &othergroup={profrgoupID van de agenda}
      if (this.profgroupid !== this.activeProfGr) {
        url = url + '&othergroup=' + this.profgroupid
      }
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.agendaDetailInfo {
  font-size: 14px;
}
.competentiebalk {
  display: flex;
  height: 20px;
}
.competentiebalk > div:first-child {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.competentiebalk > div:last-child {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.agendaTableDetailRow {
  padding: 10px;
  margin-bottom: 20px;
}
.starcount {
  color: black;
  font-size: 11px;
  vertical-align: bottom;
}
.tableinfostyle {
  display: flex;
  align-items: center;
  height: 30px;
  width: 100%;
  background-color: #eee;
  padding-left: 10px;
}
</style>
<style>
.bodyPublic .XVcolDetail {
  display: none;
}
.bodyPublic .XVdetailRow {
  word-break: inherit; /* nodig voor sterren pid215*/
}
.bodyPublic #lblBeschrijving {
  height: auto;
}
.bodyPublic .loader {
  width: 40px !important;
  height: 40px !important;
}
</style>
